
<mat-card class="p-4">
  <h2 class="text-lg font-semibold mb-4">Process Results</h2>

  <div style="display: flex; flex-wrap: wrap; gap: 24px">
    <!-- Left: Form Section -->
    <div style="flex: 1 1 60%; min-width: 300px;">
      <form [formGroup]="form" (ngSubmit)="processResults()">
        <mat-form-field appearance="fill" class="w-full mb-3">
          <mat-label>Select Course</mat-label>
          <mat-select formControlName="course_id" (ngModelChange)="loadSummary()">
            <mat-option *ngFor="let course of courseList" [value]="course.id">
              {{ course.name }}-{{course.crs_code}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100 mb-3">
          <mat-label>Select Semester</mat-label>
          <mat-select formControlName="semester_number">
            <mat-option *ngFor="let sem of semesterList" [value]="sem.number">
              Semester {{ sem.number }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100 mb-3">
          <mat-label>Select Result Type</mat-label>
          <mat-select formControlName="result_type">
            <mat-option value="regular">Regular</mat-option>
            <mat-option value="iti">ITI</mat-option>
            <mat-option value="puc">PUC</mat-option>
            <mat-option value="COB">COB</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Select Exam Month</mat-label>
          <mat-select formControlName="exam_month">
            <mat-option *ngFor="let month of months" [value]="month.months_name">
              {{ month.months_name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Select Exam Year</mat-label>
          <mat-select formControlName="exam_year">
            <mat-option *ngFor="let year of years" [value]="year.year_name">
              {{ year.year_name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <button mat-raised-button color="primary" type="submit" [disabled]="form.invalid || isLoading">
          Process
        </button>
      </form>
    </div>

    <!-- Right: Summary Table -->
    <div style="flex: 1 1 35%; min-width: 250px;">
      <h3 class="text-md font-semibold mb-3">Processed Result Summary</h3>
      <table mat-table [dataSource]="summaryList" class="mat-elevation-z1 w-full text-sm">

        <!-- Month -->
        <ng-container matColumnDef="exam_month">
          <th mat-header-cell *matHeaderCellDef> Month </th>
          <td mat-cell *matCellDef="let row"> {{ row.exam_month }} </td>
        </ng-container>

        <!-- Year -->
        <ng-container matColumnDef="exam_year">
          <th mat-header-cell *matHeaderCellDef> Year </th>
          <td mat-cell *matCellDef="let row"> {{ row.exam_year }} </td>
        </ng-container>

        <!-- Sem -->
        <ng-container matColumnDef="semester_number">
          <th mat-header-cell *matHeaderCellDef> Sem </th>
          <td mat-cell *matCellDef="let row"> {{ row.semester_number }} </td>
        </ng-container>

        <!-- Result Type -->
        <ng-container matColumnDef="result_type">
          <th mat-header-cell *matHeaderCellDef> Type </th>
          <td mat-cell *matCellDef="let row"> {{ row.result_type }} </td>
        </ng-container>

        <!-- Count -->
        <ng-container matColumnDef="count">
          <th mat-header-cell *matHeaderCellDef> Count </th>
          <td mat-cell *matCellDef="let row"> {{ row.count }} </td>
        </ng-container>

          <ng-container matColumnDef="is_processed">
          <th mat-header-cell *matHeaderCellDef> Processing Done ? </th>
          <td mat-cell *matCellDef="let row"> {{ row.is_processed }} </td>
        </ng-container>


        <tr mat-header-row *matHeaderRowDef="['exam_month','exam_year','semester_number','result_type','count', 'is_processed']"></tr>
        <tr mat-row *matRowDef="let row; columns: ['exam_month','exam_year','semester_number','result_type','count','is_processed'];" [ngClass]="{ 'unprocessed-row': row.is_processed === false }">
        </tr>
      </table>
    </div>
  </div>
</mat-card>

  
    <div class="text-center mt-4" *ngIf="isLoading">
      <mat-spinner diameter="40"></mat-spinner>
      <p class="mt-2">Processing, please wait...</p>
    </div>
  
    <div *ngIf="!isLoading && processedResults?.length > 0" class="mt-6">
      <h3 class="text-md font-semibold mb-3">Processed Results</h3>
      <div class="overflow-auto">
        <table mat-table [dataSource]="processedResults" class="mat-elevation-z2 w-full min-w-[800px]">
          <!-- Register No -->
          <ng-container matColumnDef="register_no">
            <th mat-header-cell *matHeaderCellDef> Register No </th>
            <td mat-cell *matCellDef="let row"> {{ row.register_no }} </td>
          </ng-container>
  
          <!-- SGPA -->
          <ng-container matColumnDef="sgpa">
            <th mat-header-cell *matHeaderCellDef> SGPA </th>
            <td mat-cell *matCellDef="let row"> {{ row.sgpa }} </td>
          </ng-container>
  
          <!-- CGPA -->
          <ng-container matColumnDef="cgpa">
            <th mat-header-cell *matHeaderCellDef> CGPA </th>
            <td mat-cell *matCellDef="let row"> {{ row.cgpa }} </td>
          </ng-container>
  
          <!-- Overall Raw Total -->
          <ng-container matColumnDef="overall_raw_total">
            <th mat-header-cell *matHeaderCellDef> Raw Total </th>
            <td mat-cell *matCellDef="let row"> {{ row.overall_raw_total }} </td>
          </ng-container>

              <!-- Overall Raw Total -->
              <ng-container matColumnDef="overall_processed_total">
                <th mat-header-cell *matHeaderCellDef> Processed Total </th>
                <td mat-cell *matCellDef="let row"> {{ row.overall_processed_total }} </td>
              </ng-container>
  
          <!-- Overall Processed Total -->
          <ng-container matColumnDef="total_percentage">
            <th mat-header-cell *matHeaderCellDef> % Total </th>
            <td mat-cell *matCellDef="let row"> {{ row.total_percentage }} </td>
          </ng-container>

          <ng-container matColumnDef="overall_result">
            <th mat-header-cell *matHeaderCellDef>Result </th>
            <td mat-cell *matCellDef="let row"> {{ row.overall_result }} </td>
          </ng-container>
  
          <!-- Subject Grades -->
          <ng-container *ngFor="let i of [1,2,3,4,5,6]" [matColumnDef]="'grade_sub' + i">
            <th mat-header-cell *matHeaderCellDef> Grade Sub{{ i }} </th>
            <td mat-cell *matCellDef="let row"> {{ row['grade_sub' + i] }} </td>
          </ng-container>
  
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
    </div>

  